document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.getElementById('CartDrawer');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
  });

  function renderLine(item) {
    return (
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<img src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div>' +
          '<div class="cart-line__title">' + item.product_title + '</div>' +
          '<div class="cart-line__variant">' + item.variant_title + ' &middot; Qty ' + item.quantity + '</div>' +
          '<div>' + formatMoney(item.final_line_price) + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var container = document.getElementById('CartDrawerItems');
        var subtotal = document.getElementById('CartSubtotal');
        if (!container) return;
        if (cart.item_count === 0) {
          container.innerHTML = '<div class="cart-empty">Your bag is empty.</div>';
        } else {
          container.innerHTML = cart.items.map(renderLine).join('');
        }
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        var badge = document.querySelector('.cart-count');
        if (badge) badge.textContent = cart.item_count;
      });
  }

  // Add to cart (product form)
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { openCart(); })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  // Quantity selectors
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('input');
    sel.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'down' ? -1 : 1;
        var val = Math.max(1, parseInt(input.value || '1', 10) + step);
        input.value = val;
      });
    });
  });

  // Accordions (product info)
  document.querySelectorAll('.accordion-block__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.accordion-block').classList.toggle('open');
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('.product-gallery__thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product-gallery__main img');
      if (main) main.src = thumb.dataset.fullSrc || thumb.src;
      document.querySelectorAll('.product-gallery__thumbs img').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  refreshCartDrawer();
});
